import api from './api';

const endpoint = '/city/state';

export default {
    async getCity(id: string | number){
        try {
            const {data} = await api.get(endpoint+'/'+id);
            return {data, isError: false};
        } catch (err: any) {
            return {
                data: err?.response?.data ?? {message: 'Falha ao processar requisição'},
                isError: true
            };
        }
    },

}